// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { 
//   ChevronDown, Phone, Mail, MapPin, Send, MessageSquare, 
//   Clock, CheckCircle2, Linkedin, Twitter, 
//   Facebook, Instagram, Loader2,
//   RefreshCcw // Added for captcha refresh
// } from 'lucide-react';
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// import Image1 from "../../assets/virtualphone.webp";
// import Image2 from "../../assets/virtualphone2.webp";
// import { API_URL } from '../../../Constants';

// // --- Contact Section Helpers ---
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
// };

// const itemVariants = {
//   hidden: { opacity: 0, y: 15 },
//   visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
// };

// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       required={required}
//       readOnly={readOnly}
//       className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
//         readOnly 
//         ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
//         : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
//       }`}
//     />
//   </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <textarea
//       name={name}
//       value={value}
//       onChange={onChange}
//       rows="4"
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//     />
//   </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//   <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Icon className="text-white w-4 h-4" />
//     </div>
//     <div className="text-left">
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//       <p className="text-white text-base font-bold leading-tight">{content}</p>
//       {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//     </div>
//   </motion.div>
// );

// const Vphone = () => {
//   // --- Form Logic: Updated keys to fullName and phoneNumber ---
//   const [formState, setFormState] = useState({ 
//     fullName: '', 
//     email: '', 
//     phoneNumber: '', 
//     subject: 'Virtual Phone Demo Request', 
//     message: '' 
//   });
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // --- CAPTCHA LOGIC ---
//   const [captchaText, setCaptchaText] = useState('');
//   const [userInputCaptcha, setUserInputCaptcha] = useState('');

//   const generateCaptcha = () => {
//     const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//     let result = "";
//     for (let i = 0; i < 6; i++) {
//       result += chars.charAt(Math.floor(Math.random() * chars.length));
//     }
//     setCaptchaText(result);
//     setUserInputCaptcha('');
//   };

//   useEffect(() => {
//     generateCaptcha();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === 'phoneNumber') {
//         const cleaned = value.replace(/\D/g, ''); 
//         if (cleaned.length <= 10) {
//             setFormState({ ...formState, [name]: cleaned });
//         }
//         return;
//     }
//     setFormState({ ...formState, [name]: value });
//   };

//   const validateForm = () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\d{10}$/;

//     if (!emailRegex.test(formState.email)) {
//       toast.error("Please enter a valid email address with '@'");
//       return false;
//     }
//     if (!phoneRegex.test(formState.phoneNumber)) {
//       toast.error("Phone number must be exactly 10 digits");
//       return false;
//     }
//     if (formState.fullName.trim().length < 2) {
//       toast.error("Please enter your full name");
//       return false;
//     }
//     if (userInputCaptcha.toUpperCase() !== captchaText) {
//       toast.error("Incorrect security code. Please try again.");
//       generateCaptcha();
//       return false;
//     }
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     setIsSubmitting(true);
//     try {
//       const response = await fetch(`${API_URL}/api/public/contact`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formState),
//       });

//       const result = await response.json();

//       if (response.ok && result.success) {
//         setIsSubmitted(true);
//         toast.success(result.message || "Request sent successfully!");
//         setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'Virtual Phone Demo Request', message: '' });
//         generateCaptcha();
//       } else {
//         toast.error(result.message || "Something went wrong. Please try again.");
//         generateCaptcha();
//       }
//     } catch (error) { 
//       console.error(error); 
//       toast.error("Failed to connect to the server.");
//     } finally { 
//       setIsSubmitting(false); 
//     }
//   };

//   const bgPuzzleStyle = {
//     backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
//     backgroundSize: '30px 30px',
//   };

//   return (
//     <>
//       <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
//       {/* HERO SECTION */}
//       <section className="bg-[#EEF2FC] flex flex-col md:flex-row items-start justify-between px-6 pb-10 pt-32 md:pt-40 md:px-12 lg:px-24 min-h-[85vh]">
//         <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10 text-left relative z-10 md:-mt-12">
//           <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
//             Virtual Phone Number
//           </h1>
//           <p className="text-lg text-slate-700 mb-8 leading-relaxed">
//             A Virtual Phone Number enables seamless communication by routing calls over the internet, allowing businesses to manage customer interactions globally without physical phone lines. It enhances accessibility, improves call management, and ensures a professional presence, no matter the location.
//           </p>
//           <a
//             href="#contact-start"
//             className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md hover:bg-slate-800"
//           >
//             Request a Demo
//             <ChevronDown className="w-5 h-5 animate-bounce" />
//           </a>
//         </div>

//         <div className="w-full md:w-1/2 flex justify-center relative z-10 md:-mt-24">
//           <img
//             src={Image1}
//             alt="Virtual Phone Number Hero"
//             className="w-full max-w-lg h-auto"
//           />
//         </div>
//       </section>

//       {/* NEW SECTION: WHAT IS A VIRTUAL PHONE NUMBER */}
//       <section className="bg-[#EEF2FC] pt-12 pb-20 px-6 md:px-12 lg:px-24">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-10">
//             <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 inline-block relative pb-4">
//               What is a Virtual Phone Number?
//               <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-slate-900 rounded-full"></span>
//             </h2>
//           </div>

//           <div className="flex flex-col md:flex-row items-center gap-8 md:-mt-8">
//             <div className="w-full md:w-1/2">
//               <div className="rounded-2xl overflow-hidden">
//                 <img 
//                   src={Image2}
//                   alt="Understanding Virtual Phone Numbers" 
//                   className="w-full h-auto object-cover"
//                 />
//               </div>
//             </div>

//             <div className="w-full md:w-1/2">
//               <p className="text-lg text-slate-700 leading-relaxed italic border-l-4 border-slate-300 pl-6">
//                 A Virtual Phone Number (VPN) is a telephone number that isn't directly tied to a physical phone line or a specific device. Instead, it operates through the cloud, using the internet to route calls to any chosen destination, such as a mobile phone, landline, or computer. This technology provides businesses with unparalleled flexibility, allowing teams to operate remotely while maintaining a consistent professional identity. By utilizing a virtual system, companies can establish local presence in multiple regions without the overhead costs of physical offices. It also integrates advanced features like call forwarding, automated attendants, and detailed analytics, ensuring that every customer interaction is handled with precision and care.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* SECTION 3: KEY BENEFITS */}
//       <section className="bg-[#EEF2FC] py-20 px-6 md:px-12 lg:px-24 -mt-16">
//         <div className="max-w-7xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 inline-block relative pb-4">
//               Key Benefits of Virtual Phone Numbers
//               <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-32 h-1 bg-slate-900 rounded-full"></span>
//             </h2>
//             <p className="text-lg text-slate-600 mt-6 max-w-3xl mx-auto">
//               Transform your business communication with advanced features designed for modern enterprises
//             </p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Global Presence</h3>
//               <p className="text-slate-700">
//                 Establish local numbers in multiple countries without physical offices, building trust with international customers through familiar local numbers.
//               </p>
//             </div>

//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Advanced Call Management</h3>
//               <p className="text-slate-700">
//                 Intelligent call routing, auto-attendants, call forwarding, and voicemail-to-email ensure no call is ever missed and customers are always directed to the right person.
//               </p>
//             </div>

//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Cost Efficiency</h3>
//               <p className="text-slate-700">
//                 Eliminate expensive hardware, installation costs, and international calling fees with flexible, scalable pricing that grows with your business.
//               </p>
//             </div>

//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Detailed Analytics</h3>
//               <p className="text-slate-700">
//                 Track call volume, duration, peak times, and customer satisfaction with comprehensive reporting tools that provide insights for business improvement.
//               </p>
//             </div>

//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Remote Work Ready</h3>
//               <p className="text-slate-700">
//                 Enable your team to work from anywhere while maintaining professional communication. Calls can be routed to mobile phones, laptops, or home offices seamlessly.
//               </p>
//             </div>

//             <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
//               <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
//                 <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
//                 </svg>
//               </div>
//               <h3 className="text-xl font-semibold text-slate-900 mb-4">Enhanced Security</h3>
//               <p className="text-slate-700">
//                 Enterprise-grade encryption, spam filtering, and secure cloud infrastructure ensure your business communications are protected against threats.
//               </p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* NEW 4th SECTION: REQUEST DEMO (CONTACT) */}
//       <section id="contact-start" className="py-16 relative overflow-hidden">
//         <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//         <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
//         <div className="container mx-auto px-4 relative z-10">
//           <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
            
//             {/* LEFT SIDE */}
//             <motion.div variants={itemVariants} className="space-y-8">
//               <div>
//                 <div className="inline-flex items-center gap-2 mb-2">
//                   <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                   <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">GET IN TOUCH</span>
//                 </div>
//                 <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request a <span className="text-[#F46653]">Virtual Phone Demo</span></h2>
//                 <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
//               </div>

//               <div className="space-y-3">
//                 <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                 <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
//                 <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                 <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//               </div>

//               <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
//                 <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
//                 <div className="flex gap-3">
//                   {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
//                     <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-all group">
//                       <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
//                     </motion.a>
//                   ))}
//                 </div>
//               </motion.div>
//             </motion.div>

//             {/* RIGHT SIDE - FORM */}
//             <motion.div variants={itemVariants}>
//               <div className="bg-white rounded-3xl shadow-2xl p-8">
//                 <AnimatePresence mode="wait">
//                   {isSubmitted ? (
//                     <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
//                       <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                       <h3 className="text-3xl font-bold text-gray-800 mb-4 text-center">Request Sent!</h3>
//                       <p className="text-gray-600 mb-8 text-center">Our team will get back to you within 2 hours to schedule your Virtual Phone demo.</p>
//                       <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Back to Form</button>
//                     </motion.div>
//                   ) : (
//                     <motion.div key="form">
//                       <div className="flex items-center gap-3 mb-6">
//                         <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
//                         <div><p className="text-2xl font-bold text-gray-800 text-left">Send Us a Message</p></div>
//                       </div>
//                       <form onSubmit={handleSubmit} className="space-y-5">
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                           <InputField label=" Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                         </div>
                        
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                           <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
//                           <InputField 
//                             label="Subject" 
//                             name="subject" 
//                             value="Virtual Phone Demo Request" 
//                             readOnly={true} 
//                           />
//                         </div>

//                         <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                         {/* --- ADDED CAPTCHA FIELD --- */}
//                         <div className="flex flex-col space-y-1.5 pt-2 text-left">
//                           <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                           <div className="flex items-center gap-4">
//                             <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                               <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                 {captchaText}
//                               </span>
//                             </div>
//                             <button 
//                               type="button" 
//                               onClick={generateCaptcha} 
//                               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                               title="Refresh Code"
//                             >
//                               <RefreshCcw className="w-5 h-5 text-gray-500" />
//                             </button>
//                             <div className="flex-1">
//                               <input
//                                 type="text"
//                                 placeholder="Enter code"
//                                 value={userInputCaptcha}
//                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                 required
//                               />
//                             </div>
//                           </div>
//                         </div>

//                         <motion.button 
//                           disabled={isSubmitting || userInputCaptcha.length < 6} 
//                           whileHover={{ scale: isSubmitting ? 1 : 1.02 }} 
//                           whileTap={{ scale: isSubmitting ? 1 : 0.98 }} 
//                           type="submit" 
//                           className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//                         >
//                           {isSubmitting ? (
//                             <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
//                           ) : (
//                             <>Send Message <Send className="w-5 h-5" /></>
//                           )}
//                         </motion.button>
//                       </form>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </div>
//             </motion.div>
//           </motion.div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Vphone;



import React, { useState, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom'; // Added Link import for routing
import { 
  ChevronDown, Phone, Mail, MapPin, Send, MessageSquare, 
  Clock, CheckCircle2, Linkedin, Twitter, 
  Facebook, Instagram, Loader2,
  RefreshCcw // Added for captcha refresh
} from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Image1 from "../../assets/virtualphone.webp";
import Image2 from "../../assets/virtualphone2.webp";
import { API_URL } from '../../../Constants';

// --- Contact Section Helpers ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.1 } }
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { type: "spring", stiffness: 100, damping: 20 } }
};

const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
        readOnly 
        ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed pointer-events-none select-none" 
        : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
      }`}
    />
  </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      rows="4"
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
    />
  </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
  <motion.div variants={itemVariants} className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default">
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Icon className="text-white w-4 h-4" />
    </div>
    <div className="text-left">
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
      <p className="text-white text-base font-bold leading-tight">{content}</p>
      {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
    </div>
  </motion.div>
);

const Vphone = () => {
  // --- Form Logic: Updated keys to fullName and phoneNumber ---
  const [formState, setFormState] = useState({ 
    fullName: '', 
    email: '', 
    phoneNumber: '', 
    subject: 'Virtual Phone Demo Request', 
    message: '' 
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false); // Added consent state

  // --- CAPTCHA LOGIC ---
  const [captchaText, setCaptchaText] = useState('');
  const [userInputCaptcha, setUserInputCaptcha] = useState('');

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptchaText(result);
    setUserInputCaptcha('');
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phoneNumber') {
        const cleaned = value.replace(/\D/g, ''); 
        if (cleaned.length <= 10) {
            setFormState({ ...formState, [name]: cleaned });
        }
        return;
    }
    setFormState({ ...formState, [name]: value });
  };

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formState.email)) {
      toast.error("Please enter a valid email address with '@'");
      return false;
    }
    if (!phoneRegex.test(formState.phoneNumber)) {
      toast.error("Phone number must be exactly 10 digits");
      return false;
    }
    if (formState.fullName.trim().length < 2) {
      toast.error("Please enter your full name");
      return false;
    }
    if (!consentGiven) { // Final check for Consent
      toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
      return false;
    }
    if (userInputCaptcha.toUpperCase() !== captchaText) {
      toast.error("Incorrect security code. Please try again.");
      generateCaptcha();
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch(`${API_URL}/api/public/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formState),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setIsSubmitted(true);
        toast.success(result.message || "Request sent successfully!");
        setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'Virtual Phone Demo Request', message: '' });
        setConsentGiven(false); // Reset consent after success
        generateCaptcha();
      } else {
        toast.error(result.message || "Something went wrong. Please try again.");
        generateCaptcha();
      }
    } catch (error) { 
      console.error(error); 
      toast.error("Failed to connect to the server.");
    } finally { 
      setIsSubmitting(false); 
    }
  };

  const bgPuzzleStyle = {
    backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
    backgroundSize: '30px 30px',
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
      {/* HERO SECTION */}
      <section className="bg-[#EEF2FC] flex flex-col md:flex-row items-start justify-between px-6 pb-10 pt-32 md:pt-40 md:px-12 lg:px-24 min-h-[85vh]">
        <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10 text-left relative z-10 md:-mt-12">
          <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
            Virtual Phone Number
          </h1>
          <p className="text-lg text-slate-700 mb-8 leading-relaxed">
            A Virtual Phone Number enables seamless communication by routing calls over the internet, allowing businesses to manage customer interactions globally without physical phone lines. It enhances accessibility, improves call management, and ensures a professional presence, no matter the location.
          </p>
          <a
            href="#contact-start"
            className="inline-flex items-center gap-2 px-6 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md hover:bg-slate-800"
          >
            Request a Demo
            <ChevronDown className="w-5 h-5 animate-bounce" />
          </a>
        </div>

        <div className="w-full md:w-1/2 flex justify-center relative z-10 md:-mt-24">
          <img
            src={Image1}
            alt="Virtual Phone Number Hero"
            className="w-full max-w-lg h-auto"
          />
        </div>
      </section>

      {/* NEW SECTION: WHAT IS A VIRTUAL PHONE NUMBER */}
      <section className="bg-[#EEF2FC] pt-12 pb-20 px-6 md:px-12 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 inline-block relative pb-4">
              What is a Virtual Phone Number?
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-24 h-1 bg-slate-900 rounded-full"></span>
            </h2>
          </div>

          <div className="flex flex-col md:flex-row items-center gap-8 md:-mt-8">
            <div className="w-full md:w-1/2">
              <div className="rounded-2xl overflow-hidden">
                <img 
                  src={Image2}
                  alt="Understanding Virtual Phone Numbers" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>

            <div className="w-full md:w-1/2">
              <p className="text-lg text-slate-700 leading-relaxed italic border-l-4 border-slate-300 pl-6">
                A Virtual Phone Number (VPN) is a telephone number that isn't directly tied to a physical phone line or a specific device. Instead, it operates through the cloud, using the internet to route calls to any chosen destination, such as a mobile phone, landline, or computer. This technology provides businesses with unparalleled flexibility, allowing teams to operate remotely while maintaining a consistent professional identity. By utilizing a virtual system, companies can establish local presence in multiple regions without the overhead costs of physical offices. It also integrates advanced features like call forwarding, automated attendants, and detailed analytics, ensuring that every customer interaction is handled with precision and care.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3: KEY BENEFITS */}
      <section className="bg-[#EEF2FC] py-20 px-6 md:px-12 lg:px-24 -mt-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 inline-block relative pb-4">
              Key Benefits of Virtual Phone Numbers
              <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-32 h-1 bg-slate-900 rounded-full"></span>
            </h2>
            <p className="text-lg text-slate-600 mt-6 max-w-3xl mx-auto">
              Transform your business communication with advanced features designed for modern enterprises
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Global Presence</h3>
              <p className="text-slate-700">
                Establish local numbers in multiple countries without physical offices, building trust with international customers through familiar local numbers.
              </p>
            </div>

            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Advanced Call Management</h3>
              <p className="text-slate-700">
                Intelligent call routing, auto-attendants, call forwarding, and voicemail-to-email ensure no call is ever missed and customers are always directed to the right person.
              </p>
            </div>

            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Cost Efficiency</h3>
              <p className="text-slate-700">
                Eliminate expensive hardware, installation costs, and international calling fees with flexible, scalable pricing that grows with your business.
              </p>
            </div>

            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Detailed Analytics</h3>
              <p className="text-slate-700">
                Track call volume, duration, peak times, and customer satisfaction with comprehensive reporting tools that provide insights for business improvement.
              </p>
            </div>

            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Remote Work Ready</h3>
              <p className="text-slate-700">
                Enable your team to work from anywhere while maintaining professional communication. Calls can be routed to mobile phones, laptops, or home offices seamlessly.
              </p>
            </div>

            <div className="bg-[#D0DCF2] rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
              <div className="w-14 h-14 bg-slate-900 rounded-xl flex items-center justify-center mb-6">
                <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Enhanced Security</h3>
              <p className="text-slate-700">
                Enterprise-grade encryption, spam filtering, and secure cloud infrastructure ensure your business communications are protected against threats.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* NEW 4th SECTION: REQUEST DEMO (CONTACT) */}
      <section id="contact-start" className="py-16 relative overflow-hidden">
        <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.div initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={containerVariants} className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start">
            
            {/* LEFT SIDE */}
            <motion.div variants={itemVariants} className="space-y-8">
              <div>
                <div className="inline-flex items-center gap-2 mb-2">
                  <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                  <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">GET IN TOUCH</span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">Request a <span className="text-[#F46653]">Virtual Phone Demo</span></h2>
                <p className="text-white/70 text-base leading-relaxed text-left">Our dedicated support team is available 24/7 to assist with your business communication needs.</p>
              </div>

              <div className="space-y-3">
                <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
                <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
              </div>

              <motion.div variants={itemVariants} className="pt-4 border-t border-white/20">
                <p className="text-white text-base font-bold mb-2 text-left">Connect With Us -</p>
                <div className="flex gap-3">
                  {[Linkedin, Twitter, Facebook, Instagram].map((Icon, idx) => (
                    <motion.a key={idx} whileHover={{ y: -3 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg text-white transition-all group">
                      <Icon className="w-4 h-4 group-hover:text-[#F46653] transition-colors" />
                    </motion.a>
                  ))}
                </div>
              </motion.div>
            </motion.div>

            {/* RIGHT SIDE - FORM */}
            <motion.div variants={itemVariants}>
              <div className="bg-white rounded-3xl shadow-2xl p-8">
                <AnimatePresence mode="wait">
                  {isSubmitted ? (
                    <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
                      <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                      <h3 className="text-3xl font-bold text-gray-800 mb-4 text-center">Request Sent!</h3>
                      <p className="text-gray-600 mb-8 text-center">Our team will get back to you within 2 hours to schedule your Virtual Phone demo.</p>
                      <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl">Back to Form</button>
                    </motion.div>
                  ) : (
                    <motion.div key="form">
                      <div className="flex items-center gap-3 mb-6">
                        <div className="p-3 bg-[#0C4550]/10 rounded-xl"><MessageSquare className="w-6 h-6 text-[#0C4550]" /></div>
                        <div><p className="text-2xl font-bold text-gray-800 text-left">Send Us a Message</p></div>
                      </div>
                      <form onSubmit={handleSubmit} className="space-y-5">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                          <InputField label=" Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
                          <InputField 
                            label="Subject" 
                            name="subject" 
                            value="Virtual Phone Demo Request" 
                            readOnly={true} 
                          />
                        </div>

                        <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                        {/* --- ADDED CAPTCHA FIELD --- */}
                        <div className="flex flex-col space-y-1.5 pt-2 text-left">
                          <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                          <div className="flex items-center gap-4">
                            <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                              <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                {captchaText}
                              </span>
                            </div>
                            <button 
                              type="button" 
                              onClick={generateCaptcha} 
                              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                              title="Refresh Code"
                            >
                              <RefreshCcw className="w-5 h-5 text-gray-500" />
                            </button>
                            <div className="flex-1">
                              <input
                                type="text"
                                placeholder="Enter code"
                                value={userInputCaptcha}
                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                required
                              />
                            </div>
                          </div>
                        </div>

                        {/* --- CONSENT CHECKBOX --- */}
                        <div className="flex items-start gap-3 pt-2 text-left">
                          <input
                            type="checkbox"
                            id="consent"
                            checked={consentGiven}
                            onChange={(e) => setConsentGiven(e.target.checked)}
                            className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                            required
                          />
                          <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                            I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                          </label>
                        </div>

                        <motion.button 
                          disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven} 
                          whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }} 
                          whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }} 
                          type="submit" 
                          className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {isSubmitting ? (
                            <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
                          ) : (
                            <>Send Message <Send className="w-5 h-5" /></>
                          )}
                        </motion.button>
                      </form>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Vphone;